import React from "react";
import useApi from "../useApi";
import CommonsApiClient from "../../api/commons";

export default function useDocumentos() {
  const [documento, setDocumento] = React.useState("");
  const [documentoModal, setDocumentoModal] = React.useState(false);

  const { request: getDocumento } = useApi(CommonsApiClient.documentoRoute);

  const togDocumentoModal = React.useCallback(
    async (uid, tipo) => {
      const response = await getDocumento(uid, {
        ext: tipo,
        type: "visualizar",
      });
      if (!response) return;
      const pdfBlob = new Blob([response], { type: "application/pdf" });
      const documentUrl = URL.createObjectURL(pdfBlob);
      setDocumento(documentUrl);
      setDocumentoModal(true);
    },
    [getDocumento]
  );

  const downloadDocumento = React.useCallback(
    async (uid, tipo) => {
      const response = await getDocumento(uid, {
        ext: tipo,
        type: "download",
      });
      if (!response) return;
      const blob = new Blob([response]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${uid}.${tipo}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    [getDocumento]
  );

  return {
    documento,
    documentoModal,
    setDocumentoModal,
    togDocumentoModal,
    downloadDocumento,
  };
}
